function Button({
  children,
  onClick,
  color = "blue",
  size = "md",
  disabled = false,
  className = "",
  type = "button",
}) {

  const colors = {
    blue:
      "bg-blue-600 hover:bg-blue-700 focus:ring-blue-200",

    red:
      "bg-rose-600 hover:bg-rose-700 focus:ring-rose-200",

    yellow:
      "bg-amber-500 hover:bg-amber-600 focus:ring-amber-200 text-amber-950",

    green:
      "bg-emerald-600 hover:bg-emerald-700 focus:ring-emerald-200",

    gray:
      "bg-slate-700 hover:bg-slate-800 focus:ring-slate-200",

    light:
      "bg-white hover:bg-slate-50 text-slate-700 border border-slate-300 focus:ring-slate-200",
  };

  const sizes = {
    sm:
      "w-auto min-w-20 px-3 py-2 text-xs",

    md:
      "w-full max-w-full sm:w-64 px-4 py-2 text-sm",

    lg:
      "w-full max-w-full sm:w-96 px-5 py-3 text-base",

    auto:
      "w-auto max-w-full px-4 py-2 text-sm",

    full:
      "w-full px-4 py-2.5 text-sm",
  };


  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        ${disabled ? "bg-slate-300 text-slate-500" : colors[color]}
        ${sizes[size]}
        ${color === "light" || color === "yellow" ? "" : "text-white"}
        rounded-lg
        font-semibold
        shadow-sm
        transition
        focus:outline-none
        focus:ring-4
        ${disabled ? "cursor-not-allowed shadow-none" : ""}
        ${className}
      `}
    >
      {children}
    </button>
  );
}

export default Button;
